import * as Yup from "yup";

export const changeUserPasswordValidationSchema = (t: any) =>
    Yup.object({
        currentPasswordUser: Yup.string()
            .required(t("Current password is required"))
            .min(6, t("Password must contain at least 6 characters"))
            .max(50, t("Password must contain no more than 50 characters")),
        newPasswordUser: Yup.string()
            .required(t("New password is required"))
            .min(6, t("Password must contain at least 6 characters"))
            .max(50, t("Password must contain no more than 50 characters"))
            .notOneOf([Yup.ref("currentPasswordUser")], t("New password must be different from current password")),

        confirmPasswordUser: Yup.string()
            .required(t("Confirm password is required"))
            .oneOf([Yup.ref("newPasswordUser")], t("Passwords do not match")),
    });
